export const PORTALS = {
  MODAL: 'modal-root',
  TOOLTIP: 'tooltip-root',
} as const

export type PortalKey = keyof typeof PORTALS

export function getPortalRoot(key: PortalKey): HTMLElement {
  const id = PORTALS[key]
  const element = document.getElementById(id)
  return element ?? document.body
}
